import { supabase } from '../supabaseClient'

// Closes the outgoing barista's open session using the system-computed
// expected amount (no manual recount), then opens a new session for the
// incoming barista, carrying that amount forward as their starting cash.
export async function autoRotateCashDrawer({ branchId, outgoingBarista, incomingBarista }) {
    if (!branchId || !incomingBarista?.barista_id) return

    const { data: openSession, error: fetchError } = await supabase
        .from('cash_drawer_sessions')
        .select('*')
        .eq('branch_id', branchId)
        .eq('status', 'open')
        .order('opened_at', { ascending: false })
        .limit(1)
        .maybeSingle()

    if (fetchError) { console.error('autoRotateCashDrawer fetch error:', fetchError); return }
    if (!openSession) return // nothing open yet — first barista must open manually
    if (openSession.barista_id === incomingBarista.barista_id) return // same person, no handoff

    const { data: transactions, error: txError } = await supabase
        .from('cash_drawer_transactions')
        .select('type, amount')
        .eq('session_id', openSession.session_id)

    if (txError) { console.error('autoRotateCashDrawer tx error:', txError); return }

    const payIns = (transactions || []).filter(t => t.type === 'pay_in').reduce((s, t) => s + Number(t.amount), 0)
    const payOuts = (transactions || []).filter(t => t.type === 'pay_out').reduce((s, t) => s + Number(t.amount), 0)
    const expectedAmount = Number(openSession.opening_amount) + payIns - payOuts

    const { error: closeError } = await supabase
        .from('cash_drawer_sessions')
        .update({
            status: 'closed',
            closed_by_barista_id: incomingBarista.barista_id,
            closing_amount: expectedAmount,
            expected_amount: expectedAmount,
            variance: 0,
            closed_at: new Date().toISOString(),
            is_auto_handoff: true,
            notes: [openSession.notes, `Auto-closed on handoff to ${incomingBarista.first_name} ${incomingBarista.last_name}`]
                .filter(Boolean).join(' | '),
        })
        .eq('session_id', openSession.session_id)

    if (closeError) { console.error('autoRotateCashDrawer close error:', closeError); return }

    const { error: openError } = await supabase
        .from('cash_drawer_sessions')
        .insert({
            branch_id: branchId,
            barista_id: incomingBarista.barista_id,
            status: 'open',
            opening_amount: expectedAmount,
            opening_denominations: null,
            is_auto_handoff: true,
            notes: `Auto-opened on handoff from ${outgoingBarista ? `${outgoingBarista.first_name} ${outgoingBarista.last_name}` : 'previous shift'}`,
        })

    if (openError) console.error('autoRotateCashDrawer open error:', openError)
}